import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CAMPAIGN_ACTIONS_PAGE_CONFIG = createFcmDetails('campaign_actions_page_config', {
	owner: 'Capybara',
	context: '/p/:slug/actions',
	description: 'Controls access the post-sign actions page where users can submit Supporter Voices',
	import: false,
	template: {
		enabled: true,
	},
});
